import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  roomStreamToSubscribeVORaw,
  RoomStreamToSubscribeVORaw
} from "@youm-front/room/domain";

export class RoomStreamsListResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamsListResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamsListResponseDTORaw) {
    JsonSchemaValidator.assert(RoomStreamsListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["streams"],
      properties: {
        streams: {
          type: "array",
          minItems: 0,
          maxItems: Number.MAX_SAFE_INTEGER,
          items: roomStreamToSubscribeVORaw
        }
      }
    };
  }
}

export interface RoomStreamsListResponseDTORaw {
  streams: RoomStreamToSubscribeVORaw[];
}
